// extracted by mini-css-extract-plugin
module.exports = {"wy3w6yt":"wy3w6yt","pszdhfz":"pszdhfz"};